import { reducer as reduxFormReducer } from "redux-form";
import { SUBMIT_ERROR_USER_EXISTS, DISMISS_ERROR } from "./actions";

// Use the default redux-form Reducer and add our own
// reducer function via the plugin API
const formReducer = reduxFormReducer.plugin({
  accountCreation: (state, action) => {
    switch (action.type) {
      case SUBMIT_ERROR_USER_EXISTS:
        return {
          ...state,
          submitError: {
            message: "User exists",
            email: action.email,
          },
        };
      case DISMISS_ERROR:
        return {
          ...state,
          submitError: false,
        };
      default:
        return state;
    }
  },
});

export default formReducer;
